import { V1_SITE_ID } from '../constants/tests.constants'

export const SITE_COOKIE = 'v1Info'

export const mockedCookies = [
  {
    [SITE_COOKIE]: {
      v1SiteId: V1_SITE_ID,
      tenant: 'biso-gym',
    },
  },
]

export const DEV_COOKIES = {
  [SITE_COOKIE]: {
    v1SiteId: 1,
    tenant: 'biso-gym',
    idToken: 'xxxxx',
  },
}
